import React, { useState } from 'react';

function ComSelectRecipentPopUp({
  close,
  setPatTextPopup,
  setPatEmailPopUp,
  setPatSecureEmailPopUp,
  setStaffMsgPopUp,
}) {
  const [selectedOption, setSelectedOption] = useState('text');
  const [mainSelectedOption, setMainSelectedOption] = useState('clinic');

  const handleProceed = () => {
    close();
    if (mainSelectedOption === 'patients') {
      if (selectedOption === 'text') {
        setPatTextPopup(true);
      } else if (selectedOption === 'medgreCom') {
        setPatEmailPopUp(true);
      } else if (selectedOption === 'secureMsg') {
        setPatSecureEmailPopUp(true);
      }
    } else {
      setStaffMsgPopUp(true);
    }
  };

  return (
    <>
      <div className="modalBackground">
        <div className="compose-msg-main-con grid-sec">
          <div className="comp-msg-hdr flex-sec">New Message</div>
          <div className="comp-msg-bdy grid-sec">
            <div className="comp-msg-bdy-rw grid-sec  alt-rw">
              <span className="com-hdr-msg">Please select recipient</span>
            </div>
            <div className="comp-msg-bdy-rw flex-sec">
              <div className="width100 grid-sec com-hdr-msg">
                <div className="flex-sec">
                  <span className="">
                    <input
                      onChange={() => setMainSelectedOption('patients')}
                      type="radio"
                      className="msg-inpt"
                      name="selectRecipient"
                      checked={mainSelectedOption === 'patients'}
                    />
                  </span>
                  <span className="clear-left10">Patients</span>
                </div>
              </div>
              <div className="width100 flex-sec com-hdr-msg">
                <span className="">
                  <input
                    onChange={() => setMainSelectedOption('clinic')}
                    // onClick={() => setStaffMsgPopUp(true)}
                    type="radio"
                    className="msg-inpt"
                    name="selectRecipient"
                    checked={mainSelectedOption === 'clinic'}
                  />
                </span>
                <span className="clear-left10">Clinic Users</span>
              </div>
            </div>
            {mainSelectedOption === 'patients' && (
              <>
                <div className="flex-sec clear-top10 recpnt-slectn-info">
                  Select mode
                </div>
                <div className="com-select-mode grid-sec">
                  <div className="width100 flex-sec">
                    <span className="">
                      <input
                        onChange={(e) => setSelectedOption(e.target.value)}
                        type="radio"
                        className="msg-inpt"
                        name="selectChildRecipient"
                        value="text"
                        checked={selectedOption === 'text'}
                      />
                    </span>
                    <span className="clear-left10">Text</span>
                  </div>
                  <div className="width100 flex-sec">
                    <span className="">
                      <input
                        onChange={(e) => setSelectedOption(e.target.value)}
                        type="radio"
                        className="msg-inpt"
                        name="selectChildRecipient"
                        value="medgreCom"
                        checked={selectedOption === 'medgreCom'}
                      />
                    </span>
                    <span className="clear-left10 sec-colr">
                      Medgre comm & email notifications
                    </span>
                  </div>
                  <div className="width100 flex-sec">
                    <span className="">
                      <input
                        onChange={(e) => setSelectedOption(e.target.value)}
                        type="radio"
                        className="msg-inpt"
                        name="selectChildRecipient"
                        value="secureMsg"
                        checked={selectedOption === 'secureMsg'}
                      />
                    </span>
                    <span className="clear-left10 sec-colr">
                      Secure Message sent over patient portal (for PHI)
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="comp-msg-ftr flex-sec">
            <button className="actn-yes" onClick={handleProceed}>
              Proceed
            </button>
            <button className="actn-No" onClick={close}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ComSelectRecipentPopUp;
